<template>
    <div class="algorithm-propver__container">
        <div
            v-for="(option, index) in options"
            :key="`option${index}`"
            class="algorithm-propver__content"
        >
            <div class="algorithm-propver__title">
                {{ option.label }}
            </div>
            <div class="algorithm-propver__description">
                {{ $t(`Search.propver.Preferences.algorithm.${option.key}`) }}
            </div>
        </div>
    </div>
</template>

<script>
import i18n from '../../locales/i18n';

export default {
    name: 'AlgorithmPopover',
    i18n,
    props: {
        options: {
            type: Array,
            require: true,
            default: () => [],
        },
    },
};
</script>
